<!-- 热门推荐 -->
<template>
    <div class="hot-recommend-wrap">
        <!-- 标题 -->
        <ItemTitle title="热门推荐" />

        <!-- swiper5 -->
        <swiper :options="swiperOption" :class="{'big-swiper-box': swiperNum === 5}" :style="{height: swiperNum === 3 ? '425px' : '260px'}">
            <swiper-slide style="width: auto; height: auto;" v-for="(item,index) in HotRecommendList" :key="index">
                <div class="hotRecommend" :class="{showThreeBox: swiperNum === 3, showFourBox: swiperNum === 5}" :style="{width: swiperNum === 3 ? '228px' : '124px'}">
                    <router-link :to="{path:'/bookDetail', query:{InformationId:item.id}}" target="_blank">
                        <div class="bookWrap">
                            <img :src="item.imagePath" alt="" :onerror="defaultImg" />
                            <span v-show="showRecommend">推荐</span>
                        </div>
                        <p :title="item.title">{{item.title}}</p>
                    </router-link>
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev Handover" slot="button-prev"></div>
            <div class="swiper-button-next Handover" slot="button-next"></div>
        </swiper>
    </div>
</template>

<script>
    import ItemTitle from './ItemTitle.vue'

    export default {
        name: 'HotRecommend',
        props: {
            swiperNum: { // 默认显示多少个
                type: Number,
                default: 3
            },
            showRecommend: { // 是否显示右上角推荐文字
                type: Boolean,
                default: true
            }
        },
        components: {
            ItemTitle
        },
        data() {
            return {
                swiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 68,
					// 设置分页器
					pagination: {
						el: '.swiper-pagination',
						// 设置点击可切换
						clickable: true
					},
					// 设置前进后退按钮
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					// 设置自动轮播
					autoplay: {
						delay: 5000 // 5秒切换一次
					},
					// 设置轮播可循环
					loop: true,
					loopedSlides: 5
				},
                HotRecommendList: [],
				defaultImg: 'this.src="' + require('../assets/img/default_pic.png') + '"'  // 默认封面
            }
        },
        watch: {
            swiperNum: {
                immediate: true,
                handler(newVal) {
                    if(newVal === 5) this.swiperOption.spaceBetween = 50;
                }
            }
        },
        mounted() {
            this.GetHotRecommend();
        },
        methods: {
            // 获取热门推荐
			GetHotRecommend() {
				let params = '?PageNumber=1&PageSize=5&IsRecommend=true&OrderByDictionary[DisplayIndex]=desc&OrderByDictionary[CreationDate]=desc';
				this.$fetch('/api/information' + params)
					.then((res) => {
						this.HotRecommendList = res.data;
					}).catch((err) => {
						throw err;
					});
			}
        }
    }
</script>

<style scoped>
    .hotRecommend li {
        width: 208px;
        margin-right: 40px;
    }

    .hotRecommend li:last-child {
        margin-right: 0;
    }

    .hotRecommend a:hover img {
        margin-top: 21px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, .1);
    }

    .hotRecommend a:hover span {
        top: 27px;
    }

    .hotRecommend .bookWrap {
        position: relative;
    }

    /* 展示3个的图片大小 */
    .showThreeBox .bookWrap {
        height: 353px;
    }

    .showThreeBox .bookWrap img {
        width: 228px;
        height: 325px;
        margin-top: 28px;
    }

    /* 展示5个图片大小 */
    .showFourBox .bookWrap {
        height: 188px;
    }

    .showFourBox .bookWrap img {
        width: 124px;
        height: 160px;
        margin-top: 28px;
    }

    /* 推荐 */
    .hotRecommend .bookWrap span {
        position: absolute;
        top: 34px;
        right: 6px;
        padding: 3px 4px;
		display: block;
		background: #FF5C00;
		border-radius: 2px;
		font-size: 12px;
		color: #FFFFFF;
		box-sizing: border-box;
    }

    /* 书本标题 */
    .hotRecommend p {
        font-size: 14px;
        height: 40px;
        line-height: 20px;
        word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		color: #424242;
        margin: 14px 0 12px;
    }
    
    /* swiper */
    .swiper-button-next {
        right: 0;
        left: auto;
    }

    .swiper-button-prev {
        left: 0;
        right: auto;
    }

    .swiper-button-prev,
    .swiper-button-next {
        background: rgba(0, 0, 0, .5);
        width: 44px;
        height: 44px;
        border-radius: 6px;
        transform: translateY(-50%);
        color: #FFFFFF;
    }

    .swiper-button-prev:after,
    .swiper-button-next:after {
        font-size: 25px;
        font-weight: bold;
    }

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
        bottom: 0;
    }

    .big-swiper-box .swiper-button-prev,
    .big-swiper-box .swiper-button-next {
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }

    .big-swiper-box .swiper-button-prev:after,
    .big-swiper-box .swiper-button-next:after {
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/HotRecommend.vue